module.exports = __webpack_public_path__ + "static/img/Multi-year Accessibility Plan_2019_to_2024.3a4609c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/accessibility/Multi-year Accessibility Plan_2019_to_2024.pdf
// module id = ZRY+
// module chunks = 0